import { AppSignInButton } from "../auth";
import { DualLabel } from "../ui/DualLabel";
import { InkButton } from "../ui/InkButton";
import { InkReveal } from "../ui/InkReveal";

/**
 * Landing — the signed-out gate in clerk mode, and the app's one page of
 * pure typography: a manuscript sheet whose entire argument is a single
 * letterform. अ — the first letter, the first sound — hangs from a
 * shirorekha rule at half the viewport's height, laid down once by the
 * ink-reveal wipe (instant under reduced motion). One Latin sentence
 * carries the thesis; a Devanagari echo answers it; one sindoor action
 * opens Clerk's sign-in modal. No imagery — the letterform is the art.
 *
 * Dev mode never reaches this through auth (`isSignedIn` is always true
 * there); use `?landing-preview=1` (DEV builds only — see `Router`) to
 * develop it.
 */
export function Landing() {
  return (
    <main className="paper-grain flex min-h-dvh flex-col items-center px-6 py-8">
      <section className="flex w-full max-w-md flex-1 flex-col items-center justify-center text-center">
        {/* The hero hangs from its shirorekha the way every akshara hangs
            from the headline of a word — the rule runs wider than the
            letter so अ reads as a word being begun. */}
        <div className="w-full border-t border-ink">
          {/* Rozha One leaves ascent air above the headstroke: with
              leading-none, अ's ink starts 0.2158em below the line-box top
              (measured via canvas TextMetrics — half-leading −0.21em +
              font ascent 0.998em − actual ascent 0.572em). −0.22em pulls
              the glyph's own shirorekha up into the drawn rule with ~2px
              of same-ink overlap, so bar and rule merge into one stroke
              and the letter genuinely hangs — no ivory sliver between. */}
          <p
            lang="hi"
            aria-hidden="true"
            className="font-display leading-none text-ink"
            style={{
              fontSize: "50vh",
              marginTop: "-0.22em",
              marginBottom: "-0.08em",
            }}
          >
            <InkReveal durationSeconds={1.2}>अ</InkReveal>
          </p>
        </div>

        <h1 lang="en" className="mt-8 font-latin text-2xl text-ink">
          You already speak Hindi. Now read it.
        </h1>
        <p lang="hi" className="mt-2 font-dev text-lg text-ink-soft">
          हिन्दी आप बोलते ही हैं। अब पढ़िए।
        </p>

        <div className="mt-10">
          <AppSignInButton>
            <InkButton variant="sindoor">
              <DualLabel variant="inline" en="Start" hi="शुरू करें" />
            </InkButton>
          </AppSignInButton>
        </div>
      </section>

      <footer className="w-full max-w-md border-t border-rule pt-4 text-center">
        <p className="font-latin text-xs text-ink-soft">
          <DualLabel
            en="Hindi — reading and writing"
            hi="हिन्दी — पढ़ना-लिखना"
          />
        </p>
      </footer>
    </main>
  );
}
